export default function Hot(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15" fill="none" {...props}>
			<path
				d="M4.15957 14.0401C4.15957 14.0401 -2.06687 12.6705 0.716056 5.87297C0.716056 5.87297 1.34786 6.62833 1.26099 6.99179C1.26099 6.99179 1.75625 5.27609 2.82523 4.25117C3.7431 3.3705 4.67572 0.894705 3.81559 0C3.81559 0 8.07588 0.894705 8.55008 5.36999C8.55008 5.36999 9.09501 3.94404 10.2138 3.80311C10.2138 3.80311 9.86985 4.58655 10.2138 5.76171C10.2138 5.76171 13.7428 11.8025 7.66099 13.8442C7.66099 13.8442 9.4841 11.7742 5.61781 8.22188C5.61781 8.22188 4.70625 10.1243 4.16115 10.7947C4.15957 10.7965 2.63885 12.5013 4.15957 14.0401Z"
				fill="currentColor"
			/>
		</svg>
	);
}
